import { DateTime } from 'luxon';

/**
 * Validate route date inputs once, before passing calendar days to a page.
 * @param {object} location Found location with parsed query or raw search
 * @returns {object} valid inclusive dates and an invalid-input flag
 */
function getRouteDateParams(location = {}) {
  const search = new URLSearchParams(location.search);
  const { start, finish } = location.query || {
    start: search.get('start'),
    finish: search.get('finish'),
  };
  const startDate = Array.isArray(start) ? start[0] : start;
  const finishDate = Array.isArray(finish) ? finish[0] : finish;
  // Validate calendar days independently of the eventual property timezone.
  const validStart = !startDate || DateTime.fromFormat(startDate, 'yyyy-MM-dd', { zone: 'UTC' }).isValid;
  const validFinish = !finishDate || DateTime.fromFormat(finishDate, 'yyyy-MM-dd', { zone: 'UTC' }).isValid;

  return {
    start: validStart ? startDate || undefined : undefined,
    finish: validFinish ? finishDate || undefined : undefined,
    hasInvalidDates: !validStart || !validFinish,
  };
}

export default getRouteDateParams;
